import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import styles from "./ChatbotPanel.module.css";

const normalizeUrlToCurrentHost = (url) => {
  try {
    const targetUrl = new URL(url);
    const { protocol, host } = window.location;

    if (!targetUrl.hostname.includes("nxnearby.com")) {
      return url;
    }

    targetUrl.protocol = protocol;
    targetUrl.host = host;

    return targetUrl.toString();
  } catch {
    return url;
  }
};

const JobCard = ({ job }) => {
  if (!job) return null;

  return (
    <div className={styles.jobResultCard}>
      <div className={styles.jobIcon}>
        <WorkOutlineIcon fontSize="small" />
      </div>

      <div className={styles.jobContent}>
        <div className={styles.jobTopRow}>
          <h5 className={styles.jobTitle}>{job.job_title}</h5>

          <a
            href={normalizeUrlToCurrentHost(job.job_url)}
            target="_blank"
            rel="noreferrer"
            className={styles.jobLinkIcon}
            onClick={(e) => e.stopPropagation()}
          >
            <OpenInNewIcon fontSize="small" />
          </a>
        </div>

        <div className={styles.jobMeta}>
          <span className={styles.jobBadge}>Job</span>
        </div>
      </div>
    </div>
  );
};

export default JobCard;
